import { useEffect, useState } from 'react';

const useLocalStorage = <T,>(key: string, defaultValue: T) => {
  const isStringType = typeof defaultValue === 'string';

  const [value, setValue] = useState(() => {
    const storedValue = localStorage.getItem(key);
    if (storedValue) {
      return isStringType ? storedValue : JSON.parse(storedValue);
    }
    return defaultValue;
  });

  useEffect(() => {
    const saveValue = isStringType ? value : JSON.stringify(value);
    localStorage.setItem(key, saveValue);
  }, [value, key, isStringType]);

  return [value, setValue];
};

export default useLocalStorage;
